import { Facet } from "@linkfluence/models/facet";
import { Clause } from "./clause";

export type Panel =
  | "checkbox"
  | "chips"
  | "free-text"
  | "big-list"
  | "queries-big-list"
  | "multiple-list"
  | "slider"
  | "min-max"
  | "boolean";

export const Status = {
  Include: "include",
  Exclude: "exclude",
  None: "none",
} as const;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type Status = typeof Status[keyof typeof Status];

export type Choice = {
  id: string | number;
  label: string;
  status: Status;
  category?: string;
  workspace?: string;
};

export type ClassifiedChoice = {
  id: string;
  choices: Choice[];
};

export type ClassificationFilter = {
  id: string;
  label: string;
  status: Status;
  parent?: string;
  root?: string;
  children?: boolean;
  subfilters?: { included: number; excluded: number };
};

export type ClassificationFilters = {
  "1": ClassificationFilter[];
  "2": ClassificationFilter[];
  "3": ClassificationFilter[];
};

export const ClassificationLevel = {
  One: "1",
  Two: "2",
  Three: "3",
};

export const ClassificationNode = {
  Children: "chidren",
  Parent: "parent",
  Root: "root",
};

export function getPopularChoices(facet: string): Array<any> {
  switch (facet) {
    case Facet.Languages:
      return ["en", "fr", "de", "zh-cn", "zh-tw", "es", "ru", "ko", "ja"];
    default:
      return [];
  }
}

export function canExcludeValues(facetId: string): boolean {
  return facetId !== Facet.GeoLocations && facetId !== Facet.GeoTags;
}

export function getGlobalSelectors(
  facetId: string,
  size?: "s" | "m"
): Status[] {
  if (facetId === Facet.GeoLocations || facetId === Facet.GeoTags) {
    return ["include", "none"];
  }
  return size === "m" ? ["include", "exclude", "none"] : null;
}

export type ComboFilter = {
  filters: { clause: Clause };
  id: number;
  title: string;
};
